import React, {useEffect, useState} from "react";
import {Button, Card, CardContent, Grid, MenuItem, Select, Typography} from "@material-ui/core";
import numeral from "numeral";
import moment from "moment";
import NextAnnualConDue from "../Images/NextAnnualConDue.jpg";
import NextConAmountDue from "../Images/NextConAmountDue.jpg";
import {ClientServicingCss as Styles} from "../css/ClientServicingCss";
import {PersonalChecksPaymentModal, WireTransferPaymentModal} from "../Payments";
import ContributionsAndPaymentHistory from "./ContributionsAndPaymentHistory";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EpayPayment from "./EpayPayment";
import {Dialog as GenericDialog, GenericDialogProps} from "../../dialog";
import PaymentBreakdownAccordion from "./PaymentBreakdownAccordion";
import EpayPaymentInformation from "./EpayPaymentInformation";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";
import {usePolicyContext} from "./PolicyContext";
import {getPaymentAmount} from "../../../model/payment";
import {AccountType, ClientPolicyPaymentMethod, isServicingAccessible} from "../../../constants";
import {isDebug} from "../../../utils/commonUtils";
import {useActions} from "../../../actions";
import * as ClientActions from "../../../actions/client";
import BankAccountNew from "./BankAccountNew";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { isAdmin } from "../../navigation/AdminNavigation";
import BankAccountList from "./BankAccountList";
import { Formik } from "formik";
import BankAccountDetails from "./BankAccountDetails";


const mannualPaymentMethods = [
    {
        id: 1,
        name: "Personal Check"
    },
    {
        id: 2,
        name: "Wire Transfer"
    },
    {
        id: 3,
        name: "Single ePay Payment"
    }
];

const PaymentDueAndAmount = (props: { imgSrc: string, alt: string, titleText: string, children: any }) => {
    const classes = Styles();
    const { imgSrc, alt, titleText } = props;
    return <Grid item xs={12}>
        <div className={classes.content}>
            <div className={classes.imgSec}>
                <img src={imgSrc} alt={alt} />
            </div>
            <div className={classes.textSec}>
                <Typography component="strong" variant="subtitle1"
                            className={classes.disPlay + " " + classes.mb0}>
                    {titleText}
                </Typography>
                {props.children}
            </div>
        </div>
    </Grid>;
};

export default function Contribution(props: any) {
    const classes = Styles();
    const {policy}: any = usePolicyContext();
    const clientActions = useActions(ClientActions);
    const clientDetail = useSelector((state: RootState) => state.clientAccount);
    const profile = useSelector((state: RootState) => state.profile);
    const [paymentScheduleType, setPaymentScheduleType] = useState("");
    const {user, parentPortal} = useSelector((state: RootState) => state.auth);
    const isServicing = user && user.accessType === "client" && user.demoClientId;
    const isServiceDashboardAccessible = user && user.inviteStatus && (isServicingAccessible(user) || false);
    const isParentPortal = user.role === AccountType.Individual && parentPortal;
    let clientPolicy = profile && profile.client && profile.client.clientPolicies && profile.client.clientPolicies[0];
    let clientId = profile && profile.client && profile.client && profile.client.id;
    let role:any = user && user.role;
    if (isParentPortal) {
        clientPolicy = clientDetail && clientDetail.client && clientDetail.client.clientPolicies && clientDetail.client.clientPolicies[0];
        clientId = clientDetail && clientDetail.client && clientDetail.client && clientDetail.client.id;
    }

    const [paymentMethods, setPaymentMethods] = useState(mannualPaymentMethods);
    const [monthlyActive, setMonthlyActive] = useState(false);
    const [monthlyAmount, setMonthlyAmount] = useState(0);
    const [nextContributionDate, setNextContributionDate] = useState("");
    const [nextContributionAmount, setNextContributionAmount] = useState(0);
    const [paymentFrequency, setPaymentFrequency] = useState(clientPolicy && clientPolicy.paymentFrequency || "annual");


    useEffect(() => {
        if (policy) {
            if (policy.paymentSchedule) {
                setPaymentScheduleType(policy.paymentSchedule.type)
                if (policy.paymentSchedule.type === 'AnnualEnrollment' && policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.switchPayment) {
                    setPaymentMethods([{
                        id: 4,
                        name: "Monthly Recurring ePay"
                    }]);
                    if (policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.nextPayment) {
                        setNextContributionDate(policy.paymentTimetableAnnual.nextPayment.date);
                        setNextContributionAmount(getPaymentAmount(policy.paymentTimetableAnnual.nextPayment));
                    }
                    setPaymentFrequency("annual");
                } else if (policy.paymentSchedule.type === 'MonthlyEnrollment' || policy.paymentSchedule.type === 'AnnualToMonthly') {
                    setMonthlyActive(true);
                    setPaymentMethods([]);
                    if (policy.paymentTimetableMonthly && policy.paymentTimetableMonthly.nextPayment) {
                        setNextContributionDate(policy.paymentTimetableMonthly.nextPayment.date);
                        setNextContributionAmount(getPaymentAmount(policy.paymentTimetableMonthly.nextPayment));
                    }
                    setPaymentFrequency("monthly");
                }
            } else {
                if (policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.nextPayment) {
                    setNextContributionDate(policy.paymentTimetableAnnual.nextPayment.date);
                    setNextContributionAmount(getPaymentAmount(policy.paymentTimetableAnnual.nextPayment, true));
                }
            }
        }
    }, [policy]);

    // const [showDialog, setShowDialog] = React.useState(false);
    const {
        currentYearPolicyBreakDown,
        caseDetail,
        strategyName,
    } = props;
    const [paymentMethod, setPaymentMethod] = React.useState<number>(1);
    const [open, setOpen] = React.useState(false);
    const MethodObj = {
        1: "personal_check",
        2: "wire_transfer",
        3: "ePay_transfer",
        4: "ePay_monthly_recurring",
        5: "ePay_annual_recurring"
    };
    const handlePaymentMethod = () => {
        if (currentYearPolicyBreakDown && currentYearPolicyBreakDown.payments) {
            currentYearPolicyBreakDown.payments.find(p => p.paymentType === (MethodObj[paymentMethod]));
        }
        setOpen(true);
    };
    const onClose = async () => {
        if (parentPortal) {
            // refresh profile, only for parent portal
            await clientActions.getClient(clientId, clientPolicy && clientPolicy.id)
        }

        setOpen(false)
    };

    isDebug() && console.info(clientPolicy, clientPolicy && clientPolicy.payment_method)

    const ClientPolicyPaymentMethodMapper = {
        [ClientPolicyPaymentMethod.ePay]: "ePay",
        [ClientPolicyPaymentMethod.PersonalCheck]: "Personal Check",
        [ClientPolicyPaymentMethod.WireTransfer]: "Wire Transfer",
    };

    return (
                <>
                    <Grid container spacing={2}>
                        {(isServicing || isServiceDashboardAccessible) ? 
                        <>
                        <Grid item xs={12} sm={6}>
                            <Card className={classes.cardRoot + " " + classes.cardShadow + " " + classes.radius8 + " " + classes.minHeight200}>
                                <CardContent>
                                        <Typography variant="subtitle1" component="strong" className="w100 floatLeft mb0">
                                            Manage Payments
                                        </Typography>
                                        {paymentMethods && paymentMethods.length >0 && <Typography variant="caption">
                                            Make a payment towards your annual contribution.</Typography> 
                                        }
                                            {paymentMethods && paymentMethods.length >0 && 
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Select
                                                                    className="mt20 mb15 floatLeft"
                                                                    variant="outlined"
                                                                    value={paymentMethod}
                                                                    onChange={(e: any) => {
                                                                        setPaymentMethod(e.target.value);
                                                                    }}
                                                                    fullWidth
                                                            >
                                                                {paymentMethods.map((method) => {
                                                                    return <MenuItem value={method.id}>{method.name}</MenuItem>;
                                                                })}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Button
                                                                    className="floatLeft mt25 mt0Small"
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handlePaymentMethod}
                                                            >
                                                            {isServicing ? "Payment Options" : "Make Payment"}
                                                            </Button>
                                                        </Grid>
                                                        {
                                                                parentPortal &&
                                                                clientPolicy && !!clientPolicy.payment_method &&
                                                                <Grid item xs={12}>
                                                                    <Typography variant="body2">
                                                                        You’ve selected to pay your contribution
                                                                        via {ClientPolicyPaymentMethodMapper[clientPolicy.payment_method]}.
                                                                        Once your payment is processed by NIW, you’ll get an
                                                                        email confirmation of your payment. Your payment history
                                                                        below will also reflect payment process confirmation.
                                                                    </Typography>
                                                                </Grid>
                                                        }
                                                
                                                    </Grid>
                                            }

                                            {monthlyActive && 
                                            <Grid item xs={12}>
                                                    <div className="ePayAlertBox">
                                                        <CheckCircleIcon className="mr10" />
                                                        <span><Typography variant="caption" component="strong"
                                                                        className="floatLeft w100">Recurring Monthly ePay Active</Typography>
                                                    <Typography variant="caption" className="f14 floatLeft w100">You are currently enrolled in monthly
                                                        payments of {numeral(nextContributionAmount).format("$0,0.00")} which will continue until your policy is paid in
                                                        full.</Typography>
                                                    </span>
                                                        {/*MS: Manage interface is not ready yet*/}
                                                        {/*<Link variant="caption" className="colorWhite"*/}
                                                        {/*      color="secondary" onClick={() => {*/}
                                                        {/*    setShowDialog(true);*/}
                                                        {/*}}>Manage</Link>*/}
                                                    </div>
                                                </Grid>
                                            }
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card className={classes.cardRoot + " " + classes.cardShadow + " " + classes.radius8 + " " + classes.minHeight200}>
                                <CardContent>
                                        <PaymentDueAndAmount imgSrc={NextAnnualConDue} alt={"PolicyReturnRate"} titleText={paymentFrequency === "monthly" ? "Next Monthly Contribution Due" : "Next Annual Contribution Due"}>
                                            <Typography component="strong" variant="subtitle1" className={classes.disPlay + " " + classes.mb0}>
                                                <span className="displayF">
                                                    {nextContributionDate ? moment(nextContributionDate).format("MM/DD/YYYY") : <span style={{color: "#3cda93"}}>Paid in full</span>}
                                                </span>
                                            </Typography>
                                            { ((paymentFrequency === "monthly" && isServicingAccessible(user)) || [1,2].includes(role)) && <Grid>
                                                        <Formik initialValues={()=>{}} onSubmit={()=>{}}>
                                                        {   
                                                        (policy && policy.paymentMethods && policy.paymentMethods.length > 0) && <BankAccountList paymentFrequency={paymentFrequency} callingFrom="CHANGE-PAYMENT-METHOD" />                                
                                                        }
                                                        </Formik>   
                                                </Grid>
                                            }
                                        </PaymentDueAndAmount>
                                        
                                        {/* { !isServicing &&
                                        <PaymentDueAndAmount imgSrc={NextConAmountDue} alt={"NextConAmountDue"} titleText={"Next Contribution Amount Due"}>
                                            <Typography component="strong" variant="subtitle1" className={classes.disPlay + " " + classes.mb0 + " colorRed " }>
                                                <span className="displayF">
                                                    { nextContributionAmount ? numeral(nextContributionAmount).format("$0,0.00") : <span style={{color: "#3cda93"}}>No payment due</span>}
                                                </span>
                                            </Typography>
                                        </PaymentDueAndAmount>
                                        } */}
                                </CardContent>
                            </Card>
                        </Grid>
                        </>
                        : <>
                        <Grid item xs={12}>
                            <Card className={classes.cardRoot + " " + classes.cardShadow + " " + classes.radius8 + " " + classes.minHeight170}>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} style={{justifyContent: "space-between", display: "flex"}}>
                                <PaymentDueAndAmount imgSrc={NextAnnualConDue} alt={"PolicyReturnRate"} titleText={paymentFrequency === "monthly" ? "Next Monthly Contribution Due" : "Next Annual Contribution Due"}>
                                    <Typography component="strong" variant="subtitle1" className={classes.disPlay + " " + classes.mb0}>
                                        <span className="displayF">
                                            {nextContributionDate ? moment(nextContributionDate).format("MM/DD/YYYY") : <span style={{color: "#3cda93"}}>Paid in full</span>}
                                        </span>
                                    </Typography>
                                </PaymentDueAndAmount>
                                <PaymentDueAndAmount imgSrc={NextConAmountDue} alt={"NextConAmountDue"} titleText={"Next Contribution Amount Due"}>
                                    <Typography component="strong" variant="subtitle1" className={classes.disPlay + " " + classes.mb0 + " colorRed "}>
                                        { nextContributionAmount ? numeral(nextContributionAmount).format("$0,0.00") : <span style={{color: "#3cda93"}}>No payment due</span>}
                                    </Typography>
                                </PaymentDueAndAmount>
                                </Grid>
                                <Grid item xs={12}>
                                    <span className="hLine" />
                                    <Typography variant="subtitle1" component="strong" className="mt10 w100 floatLeft mb0">
                                        Manage Payments
                                    </Typography>
                            
                            {paymentMethods && paymentMethods.length > 0 && <Typography variant="caption">Make a payment towards your annual contribution.</Typography>}
                                    <Grid container spacing={2}>
                                        {paymentMethods && paymentMethods.length >0 && <Grid item xs={12} md={12} xl={6}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Select
                                                            className="mt20 mb15 floatLeft"
                                                            variant="outlined"
                                                            value={paymentMethod}
                                                            onChange={(e: any) => {
                                                                setPaymentMethod(e.target.value);
                                                            }}
                                                            fullWidth
                                                    >
                                                        {paymentMethods.map((method) => {
                                                            return <MenuItem value={method.id}>{method.name}</MenuItem>;
                                                        })}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Button
                                                            className="floatLeft mt25 mt0Small"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handlePaymentMethod}
                                                    >
                                                    {isServicing ? "Payment Options" : "Make Payment"}
                                                    </Button>
                                                </Grid>
                                                {
                                                        parentPortal &&
                                                        clientPolicy && !!clientPolicy.payment_method &&
                                                        <Grid item xs={12}>
                                                            <Typography variant="body2">
                                                                You’ve selected to pay your contribution
                                                                via {ClientPolicyPaymentMethodMapper[clientPolicy.payment_method]}.
                                                                Once your payment is processed by NIW, you’ll get an
                                                                email confirmation of your payment. Your payment history
                                                                below will also reflect payment process confirmation.
                                                            </Typography>
                                                        </Grid>
                                                }
                                                {
                                                        isDebug() && parentPortal && clientPolicy && !!clientPolicy.payment_method &&
                                                        <pre>
                                                            {
                                                                JSON.stringify({
                                                                    cpPaymentMethod: clientPolicy.payment_method,
                                                                    paymentMethod,
                                                                    paymentMethodVal: MethodObj[paymentMethod],
                                                                    value: ClientPolicyPaymentMethodMapper[clientPolicy.payment_method]
                                                                }, null, 2)
                                                            }
                                                        </pre>
                                                }
                                            </Grid>
                                        </Grid>}

                                        {monthlyActive && <Grid item xs={12} md={12} lg={8} xl={6}>
                                                <div className="ePayAlertBox">
                                                    <CheckCircleIcon className="mr10" />
                                                    <span><Typography variant="caption" component="strong"
                                                                      className="floatLeft w100">Recurring Monthly ePay Active</Typography>
                                                <Typography variant="caption" className="f14 floatLeft w100">You are currently enrolled in monthly
                                                    payments of {numeral(nextContributionAmount).format("$0,0.00")} which will continue until your policy is paid in
                                                    full.</Typography>
                                                </span>
                                                    {/*MS: Manage interface is not ready yet*/}
                                                    {/*<Link variant="caption" className="colorWhite"*/}
                                                    {/*      color="secondary" onClick={() => {*/}
                                                    {/*    setShowDialog(true);*/}
                                                    {/*}}>Manage</Link>*/}
                                                </div>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                        </Grid>
                        </>
                        }
                   
                        <Grid item xs={12}>
                            <ContributionsAndPaymentHistory
                                    clientId={clientId}
                                    clientPolicyId={clientPolicy && clientPolicy.id}
                            />

                            {
                                    open && paymentMethod === 1 &&
                                    <PersonalChecksPaymentModal
                                            onClose={onClose}
                                            caseDetail={caseDetail}
                                            strategyName={strategyName}
                                    />
                            }
                            {
                                    open && paymentMethod === 2 &&
                                    <WireTransferPaymentModal
                                            onClose={onClose}
                                            caseDetail={caseDetail}
                                    />
                            }
                            {
                                    open && (paymentMethod === 3) &&
                                    <EpayPayment
                                            onClose={onClose}
                                            caseDetail={caseDetail}
                                    />
                            }
                            {
                                open && (paymentMethod === 4) &&
                                <PaymentManage
                                    onClose={onClose}
                                    caseDetail={caseDetail}
                                    paymentMethod={paymentMethod}
                                />
                            }
                        </Grid>
                    </Grid>
                </>
    );
}

export function PaymentManage(props) {

    const dialogProps: GenericDialogProps = {
        "aria-labelledby": "customized-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (
                <>
                    <Typography variant="body1">Set up monthly recurring ePayments for next years contribution. We
                        automatically
                        calculate any monthly payments from your current year anniversary date up to today which will be
                        included with today’s first month payment. See the breakdown below for details.</Typography>
                    <PaymentBreakdownAccordion />
                    <span className="hLine"/>
                    <EpayPaymentInformation handleClose={props.onClose} paymentMethod={props.paymentMethod}/>
                    {/*<span className="hLine W100 floatLeft"/>*/}
                    {/*<PaymentNotes />*/}
                </>
        ),
        dividers: true,
        onClose: props.onClose,
        open: true,
        title: "Set Up Monthly Recurring ePay Payments",
        titleVariant:'subtitle1'
    };

    return (<GenericDialog {...dialogProps} />);
}